// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSmileOutlinedSvg from "@fishx/icons-svg/es/asn/PSmileOutlined";
import FishxIcon from '../components/FishxIcon';

var PSmileOutlined = function PSmileOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSmileOutlinedSvg
  }));
};

PSmileOutlined.displayName = 'PSmileOutlined';
export default React.forwardRef(PSmileOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSmileOutlined.js
// module id = 3637
// module chunks = 0